export enum PAYMENT_METHOD_TYPE {
    PAYU = 'PayUPayMethod',
    PAYPAL = 'PayPalPayMethod',
}
